"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadMessage = void 0;
const base_html_1 = require("./base-html");
class DownloadMessage {
    constructor(url, recipient, replyTo = "", message = "") {
        this.url = url;
        this.recipient = recipient;
        this.replyTo = replyTo;
        this.message = message;
        this.title = `Eine Exportdatei ist bereit zum Download`;
    }
    get fileName() {
        const urlParts = this.url.split("/");
        return urlParts[urlParts.length - 1];
    }
    get text() {
        return `
Hallo,

Die Datei "${this.fileName}" ist bereit zum Download. ${this.message
            ? `

Nachricht: "${this.message}"`
            : ""}

Öffnen Sie den folgenden Link in Ihrem Browser, um den Download zu starten:

${this.url}

Bitte beachten Sie, dass der Link zum Dokument nur für 14 Tage gültig ist.

Mit freundlichen Grüßen,
Ihr Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo,`)}

            ${(0, base_html_1.paragraph)(`Die Datei <a href="${this.url}"><span style="display: inline-block; font-family: monospace;padding: 5px; margin: -5px 5px; border-radius: 5px; background-color: #fafafa; border: solid 1px #ccc;">${this.fileName}</span></a> ist bereit zum Download.`)}

            ${this.message ? (0, base_html_1.paragraph)(`Nachricht: "<b>${this.message}"</b>`) : ""}

            ${(0, base_html_1.button)("Datei Herunterladen", this.url)}

            ${(0, base_html_1.paragraph)(`Bitte beachten Sie, dass der Link zum Dokument nur für 14 Tage gültig ist.`, `font-size: ${base_html_1.fontSizeSmall}; color: ${base_html_1.colorTextLight};`)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.DownloadMessage = DownloadMessage;
//# sourceMappingURL=download-file.js.map